export const HTTP_HEADERS = {
    ACCEPT_LANGUAGE: "Accept-Language",
    DATA_GROUP: "dataGroup",
    AUTHORIZATION: "authorization",
};
